module.exports = __webpack_public_path__ + "static/media/sprite.f1da72fa.svg";